import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { groupInput, input, InputProvider } from "@redotech/ui/form";
import { memo } from "react";

export const fedexEasyReturnsForm = groupInput({
  upcharge: input<string>({
    validator: (value: string) => {
      const num = Number(value);
      if (isNaN(num)) {
        return ["Must be a valid number"];
      }
      if (num <= 0) {
        return ["Must be greater than 0"];
      }
      return [];
    },
  }),
});

export const fedexEasyReturnsDefault = { upcharge: "6" };

export type FedexEasyReturnsForm = InputProvider.Form<
  typeof fedexEasyReturnsForm
>;
export type FedexEasyReturnsValue = InputProvider.Value<
  typeof fedexEasyReturnsForm
>;

export const FedexEasyReturnsSettings = memo(function FedexEasyReturnsSettings({
  input,
}: {
  input: FedexEasyReturnsForm;
}) {
  return (
    <Flex justify="flex-start" w="full">
      <Flex flexDirection="column" gap="3xl" w="half">
        <Card title="FedEx Easy Returns">
          <Flex>
            <RedoTextInput
              description="The amount redo upcharges per Fedex Easy Return"
              IconTrailing={() => <span>USD</span>}
              inputTypeHint="number"
              label="Return fee"
              min={0}
              setValue={input.inputs.upcharge.setValue}
              step={0.01}
              value={input.inputs.upcharge.value}
            />
          </Flex>
        </Card>
      </Flex>
    </Flex>
  );
});
